import { authDomain } from '../../Common/constants';

export const authenticatedUserUrl = `${authDomain}/authenticated-user/`;
